import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import DoAsk from "./DoAsk";

class AgreementList extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            signComment: null,
            showSignComment: false,
            showDoAsk: false,
            rowKey: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async() => {
        try {
            await this.props.dispatch(this.props.AgreePers_ListForPO.execute({}, {withParams: true, withStyle: true}));
            await this.props.dispatch(this.props.AgreePers_GetSignAllForPO.execute());
        } catch (e) {
            console.error(e);
        }
    }

    refresh = async() => {
        await this.props.dispatch(this.props.AgreePers_ListForPO.refresh());
    }

    signAll = async(event) => {
        event.preventDefault();

        await this.props.dispatch(this.props.AgreePers_SignAllForPO.applyParams(this.props.AgreePers_ListForPO_Params));
        //
        if(!this.props.AgreePers_SignAllForPO.isError){
            await this.refresh();
            this.setState({
                signComment: i18next.t("Agreement_List_1", {date: (new Date()).toLocaleDateString()}),
                showSignComment: true
            });
        }
    }

    renderParams = (h) => {
        return (<>
            {h.fs.map((fi) => {
                const fn = fi.Name;
                return (<React.Fragment key={fn}>
                    <div className="row">
                        <div className="col-md-3 field-title">
                            {h.lbl(fn)}
                        </div>
                        <div className="col-md-9">
                            {h.ed(fn)}
                        </div>
                    </div>
                    <hr/>
                </React.Fragment>)
            })}
        </>)
    }

    signDocument = async(row, event) => {
        event.preventDefault();
        const rowKey = this.props.AgreePers_ListForPO.getRowKey(row);
        await this.props.dispatch(this.props.AgreePers_SignForPO.execute(rowKey));
        //
        if(!this.props.AgreePers_SignForPO.isError){
            this.setState({
                signComment: i18next.t("Agreement_List_3", {date: (new Date()).toLocaleDateString()}),
                showSignComment: true
            });
        }
    }

    getDocument = async(row, event) => {
        event.preventDefault();
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocIntId
        });
        window.open(downloadPath, '_blank');
    }

    doAsk = (row, event) => {
        event.preventDefault();

        const rowKey = this.props.AgreePers_ListForPO.getRowKey(row);
        this.setState({showDoAsk: true, rowKey: rowKey});
    }

    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "DoSign" && cellParams.row[cellParams.fieldInfo.Name]) {
            return (
                <div>
                    <label>
                        <a href="" rel="noopener noreferrer"
                           onClick={(event) => this.signDocument(cellParams.row, event)}
                           className="mr-2">{cellParams.row[cellParams.fieldInfo.Name]}</a>
                    </label>
                </div>);
        } else if (cellParams.fieldInfo.Name === "DoDownload") {
            return (
                <div>
                    <label>
                        <a href="" rel="noopener noreferrer"
                           onClick={(event) => this.getDocument(cellParams.row, event)}
                           className="mr-2">{cellParams.row.DoDownload}</a>
                    </label>
                </div>);
        } else if (cellParams.fieldInfo.Name === "DoAsk") {
            return (
                <div>
                    <label>
                        <a href="" rel="noopener noreferrer"
                           onClick={(event) => this.doAsk(cellParams.row, event)}
                           className="mr-2">{cellParams.row.DoAsk}</a>
                    </label>
                </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    render() {
        if(!this.props.AgreePers_GetSignAllForPO.isInitialized || !this.props.AgreePers_ListForPO.isInitialized)
            return null;
        const showSignAll = this.props.AgreePers_GetSignAllForPO.getField(0, "IsEnableSignAll") === 1;

        return (
            <>
                <MessageBox visible={this.state.showSignComment}
                            title={i18next.t('signComment')}
                            messageText={this.state.signComment}
                            onClose={() => {
                                this.setState({showSignComment: false}, () => this.refresh());
                            }}
                />
                {
                    this.state.showDoAsk &&
                    <DoAsk rowKey={this.state.rowKey} dispatch={this.props.dispatch}
                           dataItem={this.props.dataItem_SaveAsk}
                           dataItem_Params={this.props.dataItem_SaveAsk_Params}
                           onClose={() => {
                        this.setState({showDoAsk: false})
                    }}/>
                }
                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-list'/> {i18next.t("Agreement_List_4")}</>}
                                    showInstruction={false}
                                    showSplitterLine={true} canCollapse={false}>
                    {showSignAll &&
                        <button className="btn btn-regular -wide -goahead mb-2"
                            onClick={this.signAll}>{i18next.t("Agreement_List_2")}
                    </button>
                    }
                    <ComplexParam parentDataItem={this.props.AgreePers_ListForPO} className="mb-2"
                                  dataItem={this.props.AgreePers_ListForPO_Params}
                                  renderParams={this.renderParams}
                                  showApplyButton={false} autoApplyParams={true}
                                  readOnly={false} showSearchBar={false}
                                  rootPath="/"/>
                    <GridView dataItem={this.props.AgreePers_ListForPO} renderCellEx={this.renderCellEx}
                              useItemStyle={true}
                    />
                </PlaceholderWrapper>
            </>
        )
    }
}

AgreementList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    AgreePers_ListForPO: PropTypes.object,
    AgreePers_ListForPO_Params: PropTypes.object,
    AgreePers_SignForPO: PropTypes.object,
    dataItem_SaveAsk: PropTypes.object,
    dataItem_SaveAsk_Params: PropTypes.object,
    AgreePers_GetSignAllForPO: PropTypes.object,
    AgreePers_SignAllForPO: PropTypes.object
}

AgreementList.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        AgreePers_ListForPO: state.docflowState.AgreePers_ListForPO,
        AgreePers_ListForPO_Params: state.docflowState.AgreePers_ListForPO_Params,
        AgreePers_SignForPO: state.docflowState.AgreePers_SignForPO,
        dataItem_SaveAsk: state.docflowState.AgreePersAsk_SaveAsk,
        dataItem_SaveAsk_Params: state.docflowState.AgreePersAsk_SaveAsk_Params,
        AgreePers_GetSignAllForPO: state.docflowState.AgreePers_GetSignAllForPO,
        AgreePers_SignAllForPO: state.docflowState.AgreePers_SignAllForPO
    }
}

export default connect(mapStateToProps)(AgreementList)